import { useTranslation } from 'react-i18next';

// Two-letter typographic toggle. Click switches the entire app to the other
// language; on the post-login profile page this also fires a PATCH to persist
// PrtUsr.Lng so the choice survives across devices.
interface LangToggleProps {
    onPersist?: (lng: 'en' | 'ar') => void;
    className?: string;
}

export default function LangToggle({ onPersist, className = '' }: LangToggleProps) {
    const { i18n } = useTranslation();
    const current = (i18n.language || 'en').startsWith('ar') ? 'ar' : 'en';
    const next: 'en' | 'ar' = current === 'ar' ? 'en' : 'ar';

    function flip() {
        void i18n.changeLanguage(next);
        onPersist?.(next);
    }

    return (
        <button
            type="button"
            onClick={flip}
            className={`group inline-flex items-center gap-2 text-[11px] uppercase tracking-widest2 text-ink-muted hover:text-ink-on transition-colors ${className}`}
            aria-label={`Switch language to ${next === 'ar' ? 'Arabic' : 'English'}`}
        >
            <span className={current === 'en' ? 'text-ink-on' : 'text-ink-muted'}>EN</span>
            <span aria-hidden="true" className="h-px w-3 bg-slate-line group-hover:bg-ember transition-colors" />
            <span className={current === 'ar' ? 'text-ink-on' : 'text-ink-muted'}>AR</span>
        </button>
    );
}
